<template>
  <AuthLayout :mode="mode">
    <Section :heading="listing?.listing?.machine" :mode="mode" />
    <AppCard :mode="mode">
      <template #body>
        <RecordDetails :mode="mode" :data="listingDetails" />
        <div
          class="mt-6 divide-y overflow-hidden rounded-xl border sm:mt-4"
          :class="[
            mode === 'dark'
              ? 'divide-dark-border border-dark-border bg-dark-sidebar'
              : 'divide-border-10 border-border-10 bg-white-100',
          ]"
        >
          <div
            class="grid grid-cols-2 divide-x sm:grid-cols-1 sm:divide-x-0 sm:divide-y"
            :class="[
              mode === 'dark' ? 'divide-dark-border' : 'divide-border-10',
            ]"
          >
            <div
              class="p-4 text-[15px] font-medium sm:text-[14px]"
              :class="[mode === 'dark' ? 'text-dark-text' : 'text-black-80']"
            >
              <div class="grid gap-1">
                <span
                  class="font-semibold"
                  :class="[
                    mode === 'dark' ? 'text-white-100' : 'text-black-100',
                  ]"
                  >Contact</span
                >
                <RouterLink
                  :to="{
                    name: 'contact-details',
                    params: { id: listing?.listing?.contact_id },
                  }"
                  class="underline hover:text-primary-100"
                >
                  {{ listing?.listing?.contact_name }}</RouterLink
                >
                <span
                  >Work Phone:
                  {{ listing?.contact?.work_phone }}</span
                >
                <span>Email: {{ listing?.contact?.email  }}</span>
              </div>
            </div>
            <div
              class="p-4 text-[15px] font-medium sm:text-[14px]"
              :class="[mode === 'dark' ? 'text-dark-text' : 'text-black-80']"
            >
              <div class="grid gap-1">
                <span
                  class="font-semibold"
                  :class="[
                    mode === 'dark' ? 'text-white-100' : 'text-black-100',
                  ]"
                  >Listed by</span
                >
                <RouterLink
                  :to="{
                    name: 'member-details',
                    params: { id: listing?.member?.member_id },
                  }"
                  class="underline hover:text-primary-100"
                >
                  {{
                    listing.member?.company_name ? listing.member.company_name : "-"
                  }}</RouterLink
                >
                <span v-if="member.address1">{{ listing?.member?.address1 }}</span>
                <span v-if="member.address2">{{ listing?.member?.address2 }}</span>
                <span
                  >{{ listing?.member?.city }}, {{ listing?.member?.state_region }}
                  {{ listing?.member?.zip }}, {{ listing?.member.country }}</span>
                <span v-if="listing?.member?.company_phone1 || listing?.member?.company_phone2"
                  >Phone:
                  {{
                    listing?.member.company_phone1
                      ? listing?.member.company_phone1
                      : listing?.member.company_phone2
                  }}</span
                >
                <span v-if="listing.member.fax">Fax: {{ listing?.member?.fax }}</span>
                <span v-if="listing.member.url">URL: {{ listing?.member?.url }}</span>
              </div>
            </div>
          </div>
        </div>
      </template>
    </AppCard>
  </AuthLayout>
</template>

<script>
import Section from "@C/Common/Section.vue";
import { useUserStore } from "@S/user";
import { useToastStore } from "@S/toast";
import { useLoaderStore } from "@S/loader";
import ApiRequest from "@L/ApiRequest";
import { useGlobalErrorHandler } from "@L/errorHandler";
import AuthLayout from "@A/AuthLayout.vue";
import AppCard from "@C/Common/AppCard.vue";
import RecordDetails from "@C/Common/RecordDetails.vue";

export default {
  name: "ListingDetails",
  components: {
    AuthLayout,
    Section,
    AppCard,
    RecordDetails,
  },
  data() {
    return {
      id: "",
      listing: {},
    };
  },
  props: {
    mode: String,
  },
  setup() {
    const userStore = useUserStore();
    const toastStore = useToastStore();
    const loaderStore = useLoaderStore();
    const { handleError } = useGlobalErrorHandler();
    return {
      userStore,
      toastStore,
      loaderStore,
      handleError,
    };
  },
  created() {
    this.id = this.$route.params.id;
  },
  mounted() {
    this.getListing();
  },
  methods: {
    async getListing() {
      this.loaderStore.setIsLoading(true);
      try {
        const { data } = await ApiRequest().get(`/listing/${this.id}`);
        if (data) {
          this.listing = data;
        }
      } catch (e) {
        this.handleError(e);
      } finally {
        this.loaderStore.setIsLoading(false);
      }
    },
  },
  computed: {
    loggedInUser() {
      return this.userStore.user;
    },
    contact() {
      return this.loggedInUser.contact;
    },
    member() {
      return this.loggedInUser.member;
    },
    listingDetails() {
      const allDetails = [
        {
          name: "Manufacturer",
          value: this.listing?.listing?.mfr,
        },
        {
          name: "Machine",
          value: this.listing?.listing?.machine,
        },
        {
          name: "Model",
          value: this.listing?.listing?.model,
        },
        {
          name: "Buy / Sell",
          value: this.listing?.listing?.buy_sell,
        },
        {
          name: "Qty",
          value: this.listing?.listing?.qty,
        },
        {
          name: "Price",
          value: this.listing?.listing?.price,
        },
        {
          name: "Listed on",
          value: this.listing?.listing?.post_date,
          isDate: true,
        },
        {
          name: "Location",
          value: this.listing?.listing?.location,
        },
        {
          name: "Comments",
          value: this.listing?.listing?.comments,
        },
        {
          name: "Details",
          value: this.listing?.powersearch?.details,
          isHtml: true
        },
      ];
      
      // Filter out items with falsy values
      return allDetails.filter(item => item.value);
    },
  },
};
</script>
